<i18n>
{
  "fr": {
    "configuratorGlassSettingsGraduation": {
      "yes": "Avec",
      "no": "Sans",
      "label": "Graduation :"
    }
  }
}
</i18n>

<template>
  <div
    :class="[
      `${BLOCK_SELECTOR}`,
      {
        [`${BLOCK_SELECTOR}--disabled`]:
          !$store.state.configurator.isGraduationEnable || !isGraduationMovable,
      },
    ]"
  >
    <div
      :class="[
        `${BLOCK_SELECTOR}__grid`,
        { [`${BLOCK_SELECTOR}__grid--is-open`]: isGraduationVisible },
      ]"
    >
      <div :class="`${BLOCK_SELECTOR}__main-selector`">
        <div
          :class="`${BLOCK_SELECTOR}__label`"
          v-text="$t('configuratorGlassSettingsGraduation.label')"
        ></div>

        <fieldset :class="`${BLOCK_SELECTOR}__fieldset`">
          <label :class="`${BLOCK_SELECTOR}__label option-picker__label`">
            <input
              :id="`tab`"
              :class="`${BLOCK_SELECTOR}__radio option-picker__input`"
              :value="false"
              :checked="isGraduationVisible === false"
              name="graduation"
              type="radio"
              @change="isGraduationVisible = false"
            />

            <ConfiguratorColoredDot
              :class="`${BLOCK_SELECTOR}__color-dot option-picker__colored-dot`"
              :active="isGraduationVisible === false"
              :title="$t('configuratorGlassSettingsGraduation.no')"
              variant
              color="#fff"
            />
            <span :class="`${BLOCK_SELECTOR}__label-text`">
              {{ $t('configuratorGlassSettingsGraduation.no') }}
            </span>
          </label>
          <label :class="[`${BLOCK_SELECTOR}__label option-picker__label`]">
            <input
              :id="`tab`"
              :class="`${BLOCK_SELECTOR}__radio option-picker__input`"
              :value="true"
              :checked="isGraduationVisible === true"
              name="graduation"
              type="radio"
              @change="isGraduationVisible = true"
            />

            <ConfiguratorColoredDot
              :class="`${BLOCK_SELECTOR}__color-dot option-picker__colored-dot`"
              :active="isGraduationVisible === true"
              :title="$t('configuratorGlassSettingsGraduation.yes')"
              variant
              color="#fff"
            />

            <span :class="`${BLOCK_SELECTOR}__label-text`">
              {{ $t('configuratorGlassSettingsGraduation.yes') }}
            </span>
          </label>
        </fieldset>
      </div>
      <div :class="`${BLOCK_SELECTOR}__content-box`">
        <div :class="`${BLOCK_SELECTOR}__slider-wrapper`">
          <input
            v-model="currentGraduationPosition"
            :class="`${BLOCK_SELECTOR}__slider`"
            type="range"
            :aria-label="$t('configuratorGlassSettingsGraduation.label')"
            :disabled="!isGraduationVisible || !isGraduationMovable"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import {
  ConfiguratorAction,
  ConfiguratorGetters,
  mapGetters as mapConfiguratorGetters,
  prefixType as prefixConfiguratorType,
} from '../../../store/modules/configurator';
import ConfiguratorColoredDot from '../ConfiguratorColoredDot';

export default {
  name: 'ConfiguratorGlassSettingsGraduation',
  components: { ConfiguratorColoredDot },
  data() {
    return {
      BLOCK_SELECTOR: 'configurator-glass-settings-graduation',
      isGraduationSliderModalActive: false,
      debounceGraduationPositionUpdate: debounce(
        this.updateGraduationPosition,
        250
      ),
    };
  },
  computed: {
    ...mapConfiguratorGetters({
      isGraduationEditable: ConfiguratorGetters.IS_GRADUATION_EDITABLE,
      isGraduationMovable: ConfiguratorGetters.IS_GRADUATION_MOVABLE,
    }),
    activeView() {
      return this.$store.state.configurator.layout.activeView;
    },
    currentGraduationPosition: {
      get() {
        return this.$store.state.configurator.graduationPosition;
      },
      set(graduationPosition) {
        this.debounceGraduationPositionUpdate(graduationPosition);
      },
    },
    isGraduationVisible: {
      get() {
        return this.$store.state.configurator.isGraduationEnable;
      },
      set(isGraduationEnable) {
        this.$store.dispatch(
          prefixConfiguratorType(ConfiguratorAction.SET_ACTIVE_STATE),
          { isGraduationEnable, fallbackWhenNotFound: false }
        );
      },
    },
  },
  watch: {
    activeView() {
      this.isGraduationSliderModalActive = false;
    },
    isGraduationMovable(newValue) {
      if (newValue === false) {
        this.$store.dispatch(
          prefixConfiguratorType(ConfiguratorAction.SET_ACTIVE_STATE),
          {
            graduationPosition: 50,
            shouldCenterCameraOnGraduation: false,
            fallbackWhenNotFound: true,
          }
        );
      }
    },
  },
  methods: {
    toggleGraduationSliderModal() {
      this.isGraduationSliderModalActive = !this.isGraduationSliderModalActive;
    },
    updateGraduationPosition(graduationPosition) {
      this.$store.dispatch(
        prefixConfiguratorType(ConfiguratorAction.SET_ACTIVE_STATE),
        { graduationPosition, fallbackWhenNotFound: false }
      );
    },
  },
};
</script>

<style scoped lang="scss">
.configurator-glass-settings-graduation {
  $block-selector: &;

  display: flex;
  gap: 0.5rem;
  align-items: center;

  &__grid {
    display: grid;
    width: 100%;
    row-gap: 0.5rem;
    grid-template-rows: auto 0fr;
    transition: grid-template-rows 0.3s;

    &--is-open {
      grid-template-rows: auto 1fr;
    }
  }

  &__slider-wrapper {
    display: flex;
    padding: 1rem;
    transition: opacity 0.5s;

    @include breakpoint($breakpoint-configurator-glass-settings-picker-xxl) {
      background: $color-gray-whild-sand;
      border-radius: $configurator-glass-settings-picker-group-border-radius-item-picker-xxl;
      padding: $configurator-glass-settings-picker-option-padding-vertical-xxl-inside
        $configurator-glass-settings-picker-option-padding-horizontal-xxl
        $configurator-glass-settings-picker-option-padding-vertical-xxl-inside
        $configurator-glass-settings-picker-option-padding-horizontal-xxl;
    }

    #{$block-selector}--disabled & {
      opacity: 0;
    }
  }

  &__main-selector {
    height: 2rem;
    display: flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: flex-start;
  }

  &__content-box {
    min-height: 0;
    overflow: hidden;
  }

  &__slider {
    @extend %base-range;

    width: 100%;
    transition: opacity 0.5s;

    #{$block-selector}--disabled & {
      opacity: 0;
      cursor: default;
    }
  }

  &__fieldset {
    display: flex;
    gap: 1.875rem;
    padding: 0;
    border: none;
  }

  &__label {
    display: flex;
  }

  &__color-dot {
    margin-bottom: 0.25em;
    font-size: 1.25rem;
  }

  &__label-text {
    font-weight: 600;
    font-size: 1rem;
    color: #2034a6;
    text-transform: capitalize;
  }
}
</style>
